var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Friend {
  constructor(data) {
    __publicField(this, "hasPhoto");
    __publicField(this, "id");
    /**
     * Whether friend is a playing or non-playing friend.
     *
     * Only used on the LINE platform. On other platforms all friends are playing friends.
     */
    __publicField(this, "isPlayer", true);
    __publicField(this, "name");
    /**
     * URL to the player's public profile picture.
     *
     * A default picture URL is used in case of users without a profile picture.
     *
     * On the LINE platform this points to the original uploaded picture which can vary in size.
     * Use `playerPhotoSmall` and `playerPhotoLarge` instead for fixed image sizes.
     */
    __publicField(this, "photo");
    /**
     * URL to the player's public profile picture, resized to 200x200px.
     *
     * `undefined` if the player has not set a profile picture.
     *
     * Only defined on the LINE platform.
     */
    __publicField(this, "photoLarge");
    /**
     * URL to the player's public profile picture, resized to 51x51px.
     *
     * `undefined` if the player has not set a profile picture.
     *
     * Only defined on the LINE platform.
     */
    __publicField(this, "photoSmall");
    __publicField(this, "_customProperties");
    this.hasPhoto = true;
    this._applyData(data);
  }
  static fromExternalFriend(externalFriend) {
    return new Friend({
      providerKey: externalFriend.id,
      displayName: externalFriend.name,
      pictureUrl: externalFriend.profilePicture,
      isPlayer: externalFriend.isPlayer
    });
  }
  _applyData(data) {
    if (Array.isArray(data)) {
      this.id = data[0];
      this.name = data[1];
      this.photo = data[2];
    } else if (
      // Facebook and LINK platforms:
      typeof data === "object" && "getID" in data && typeof data.getID === "function" && typeof data.getName === "function" && typeof data.getPhoto === "function"
    ) {
      this.id = data.getID();
      this.name = data.getName() || "";
      this.photo = data.getPhoto() || "";
    } else if (typeof data === "object" && "providerKey" in data) {
      this.id = data.providerKey;
      this.isPlayer = data.isPlayer;
      this.name = data.displayName;
      this.photo = data.pictureUrl;
      if (!this.photo) {
        this.hasPhoto = false;
      } else {
        this.photoLarge = this.photo + "/large";
        this.photoSmall = this.photo + "/small";
      }
    } else {
      throw Error("Unrecognized friend object: " + data);
    }
  }
}
export {
  Friend,
  Friend as default
};
